<header class="parent-dialog__header" mat-dialog-title>
  <div class="parent-dialog__header-main">
    <div class="parent-dialog__header-icon" aria-hidden="true">
      <img src="/public/svgs/add-kid.svg" alt="" width="18" height="18" />
    </div>
    <div class="parent-dialog__header-copy">
      <h2 class="parent-dialog__title">
        @if (requiresDocumentVerification()) {
          {{ 'app.components.pendingKid.verifyTitle' | translate }}
        } @else {
          {{ 'app.components.pendingKid.title' | translate }}
        }
      </h2>
      <p class="parent-dialog__subtitle">
        @if (requiresDocumentVerification()) {
          {{ 'app.components.pendingKid.verifySubTitle' | translate }}
        } @else {
          {{ 'app.components.pendingKid.subTitle' | translate }}
        }
      </p>
    </div>
  </div>
  <button
    type="button"
    class="parent-dialog__close"
    [attr.aria-label]="'app.components.pendingKid.close' | translate"
    (click)="discard()"
  >
    <img src="/public/svgs/x-close.svg" alt="" width="18" height="18" aria-hidden="true" />
  </button>
</header>

<mat-dialog-content class="parent-dialog__body">
  @if (!requiresDocumentVerification()) {
    <section class="parent-dialog__section">
      <span class="parent-dialog__section-label">
        {{ 'app.components.pendingKid.kidLabel' | translate }}
      </span>

      <article class="parent-dialog__kid-card">
        <span class="parent-dialog__kid-card-avatar">
          @if (data.user.avatar) {
            <img
              [src]="data.user.avatar"
              [alt]="data.user.firstName"
            />
          } @else {
            <span>{{ { firstName: data.user.firstName, lastName: data.user.lastName } | initials }}</span>
          }
        </span>
        <span class="parent-dialog__kid-card-copy">
          <span class="parent-dialog__kid-card-name">
            {{ data.user.firstName }} {{ data.user.lastName }}
          </span>
          <span class="parent-dialog__kid-card-meta">{{ data.user.email }}</span>
        </span>
      </article>
    </section>
  } @else {
    <section class="parent-dialog__section">
      <article class="parent-dialog__kid-card parent-dialog__kid-card--compact">
        <span class="parent-dialog__kid-card-avatar">
          @if (data.user.avatar) {
            <img
              [src]="data.user.avatar"
              [alt]="data.user.firstName"
            />
          } @else {
            <span>{{ { firstName: data.user.firstName, lastName: data.user.lastName } | initials }}</span>
          }
        </span>
        <span class="parent-dialog__kid-card-copy">
          <span class="parent-dialog__kid-card-name">
            {{ data.user.firstName }} {{ data.user.lastName }}
          </span>
        </span>
      </article>
    </section>

    <app-kid-document-verify
      [kidId]="data.user.id"
      [kidFirstName]="data.user.firstName"
      [kidLastName]="data.user.lastName"
      [kidBirthDate]="data.user.birthDate"
      (completed)="onVerificationCompleted()"
      (cancelled)="discard()"
    />
  }
</mat-dialog-content>

@if (!requiresDocumentVerification()) {
  <mat-dialog-actions align="end" class="parent-dialog__actions parent-dialog-actions">
    <app-parent-button variant="ghost" [disabled]="isVerifying()" (clicked)="discard()">
      {{ 'app.components.pendingKid.discard' | translate }}
    </app-parent-button>

    <app-parent-button
      variant="primary"
      [loading]="isVerifying()"
      [disabled]="isVerifying()"
      (clicked)="verify()"
    >
      @if (!isVerifying()) {
        <img src="/public/svgs/check-w.svg" alt="" width="14" height="14" aria-hidden="true" />
      }
      {{ 'app.components.pendingKid.confirm' | translate }}
    </app-parent-button>
  </mat-dialog-actions>
}
